import { auth } from './lib/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import createLogin from './login';
import createBuyPlan from './buy-plan';
import createUserStatus from './user-status';
import createProfile from './profile';
import createSubscriptionStatus from './subscription-status';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll<HTMLElement>('[data-login]').forEach(createLogin);
});

window.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll<HTMLElement>('[data-buy-plan]')
		.forEach(createBuyPlan);
});

window.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll<HTMLElement>('[data-user-status]')
		.forEach(createUserStatus);
});

window.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll<HTMLElement>('[data-profile]')
		.forEach(createProfile);
});

window.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll<HTMLElement>('[data-subscription-status]')
		.forEach(createSubscriptionStatus);
});

window.addEventListener('DOMContentLoaded', () => {
	onAuthStateChanged(auth, (user) => {
		const hideLoggedIn = document.querySelectorAll<HTMLElement>(
			'[data-hide-logged-in]',
		);
		const hideLoggedOut = document.querySelectorAll<HTMLElement>(
			'[data-hide-logged-out]',
		);
		const userName = document.querySelectorAll<HTMLElement>('[data-user-name]');

		if (user) {
			hideLoggedIn.forEach((el) => (el.style.display = 'none'));
			hideLoggedOut.forEach((el) => el.style.removeProperty('display'));
			userName.forEach(
				(el) => (el.textContent = user.displayName || user.email),
			);
		} else {
			hideLoggedIn.forEach((el) => el.style.removeProperty('display'));
			hideLoggedOut.forEach((el) => (el.style.display = 'none'));
			userName.forEach((el) => (el.textContent = ''));
		}
	});
});
